module.exports = __webpack_public_path__ + "static/media/Hamster-web-logo.f97ba901.png";